module.exports = __webpack_public_path__ + "static/media/buyed.65a69487.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/buyed.png
// module id = 410
// module chunks = 0